// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".version-name-col  {\n\tpadding: 8px;\n}", "",{"version":3,"sources":["VersionName.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb","file":"VersionName.css","sourcesContent":[".version-name-col  {\n\tpadding: 8px;\n}"]}]);
// Exports
module.exports = exports;
